export default __webpack_public_path__ + "static/media/burger.30998e7a.svg";